import React, { useState, useEffect } from "react";

const AddRupee = () => {
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const u = JSON.parse(localStorage.getItem("user"));
    setUser(u);
  }, []);

  const startPayment = async () => {
    if (!amount || amount < 10) {
      alert("Minimum ₹10 enter karo");
      return;
    }

    if (!user) {
      alert("User not logged in");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(
        `https://rcfinder.online/api/create_cashfree_order.php?amount=${amount}&user_id=${user.id}`
      );
      
      const data = await res.json();

      if (!data.status) {
        alert("Order Create Failed");
        setLoading(false);
        return;
      }

      const cashfree = new window.Cashfree({ mode: "PROD" });

      cashfree.checkout({
        paymentSessionId: data.qr,
        redirectTarget: "_self"
      });

    } catch (err) {
      alert("Payment Init Failed");
      console.log(err);
    }

    setLoading(false);
  };

  return (
    <div style={{maxWidth:400, margin:"40px auto", textAlign:"center"}}>
      <h2>Add Rupee to Wallet</h2>

      <input
        type="number"
        placeholder="Enter Amount (₹)"
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
        style={{
          padding:"10px",
          width:"100%",
          marginTop:"15px",
          borderRadius:"5px"
        }}
      />

      <button
        onClick={startPayment}
        style={{
          padding:"10px",
          marginTop:"15px",
          width:"100%",
          background:"green",
          color:"#fff",
          border:"none",
          borderRadius:"5px",
          cursor:"pointer"
        }}
        disabled={loading}
      >
        {loading ? "Please wait..." : "Add Rupee"}
      </button>
    </div>
  );
};

export default AddRupee;
